<template>
  <IndicatorCard
    :loading="loading"
    :has-data="historicalMigration.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum equipamento encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong>Total: {{ total }}</strong>

          <div>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="historicalMigration"
              class="main-table"
              :hide-default-footer="!filterProp.data"
              hide-default-header
              :header-props="headerProps"
              :items-per-page="7"
              :mobile-breakpoint="0"
            >
              <template #header="{ props, on }">
                <thead>
                  <tr>
                    <th
                      class="text-center"
                      v-for="header in props.headers"
                      :key="header.value"
                    >
                      <v-simple-checkbox
                        v-if="header.value === 'data-table-select'"
                        v-model="props.everyItem"
                        :indeterminate="props.someItems && !props.everyItem"
                        color="purple"
                        @input="on['toggle-select-all']"
                      ></v-simple-checkbox>

                      <div>
                        <v-hover v-slot="{ hover }">
                          <div>
                            <span>{{ $t(header.text) }}</span>
                            <v-icon
                              v-if="
                                hover &&
                                header.value != 'data-table-select' &&
                                header.value != 'actions'
                              "
                              color="white"
                              class="mx-2"
                              @click="on.sort(header.value)"
                            >
                              {{
                                props.options.sortBy.includes(header.value)
                                  ? `mdi-chevron-down`
                                  : `mdi-chevron-up`
                              }}
                            </v-icon>
                          </div>
                        </v-hover>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.equipmentIdentification`]="{ item }">
                {{ item.equipmentIdentification }}
              </template>

              <template v-slot:[`item.equipmentName`]="{ item }">
                {{ item.equipmentName }}
              </template>

              <template v-slot:[`item.equipmentPropertyCode`]="{ item }">
                {{ item.equipmentPropertyCode }}
              </template>

              <template v-slot:[`item.departmentSourceName`]="{ item }">
                {{ item.departmentSourceName }}
              </template>

              <template v-slot:[`item.departmentDestinyName`]="{ item }">
                {{ item.departmentDestinyName }}
              </template>
              <template v-slot:[`item.dateFormated`]="{ item }">
                {{ item.dateFormated }}
              </template>
              <template v-slot:[`item.reason`]="{ item }">
                {{ item.reason ? item.reason : $t('Sem registros') }}
              </template>
            </v-data-table>

            <div class="pagination" v-if="!filterProp.data">
              <div class="item-pagination block-two">
                <v-pagination
                  class="pagination-item"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

    <template #review>
      <v-row class="ma-0">
        <v-col cols="12" v-if="isResult && review">
          <strong>{{ $t('Análise crítica') }}</strong>
          <p v-html="review"></p>
        </v-col>
        <v-col cols="12" v-else-if="!isResult">
          <tiptap-vuetify
            v-model="filter.review"
            :extensions="extensions"
            :label="$t('Análise crítica')"
            :placeholder="
              $t('Digite sua análise crítica para o indicador abaixo')
            "
            :card-props="{ flat: true, outlined: true, rounded: true }"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
          ></tiptap-vuetify>
        </v-col>
      </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data() {
    return {
      excelLoading: false,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      startDate: null,
      endDate: null,
      apiService: new ApiService(),
      loading: true,
      historicalMigration: [],
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      calibrationSchedule: [],
      calibrationExecuted: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      pager: {},
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'equipmentIdentification',
          sortable: false,
        },
        {
          text: 'Nome do equipamento',
          align: 'center',
          value: 'equipmentName',
          sortable: false,
        },
        {
          text: 'Cod. Patrimônio',
          align: 'center',
          value: 'equipmentPropertyCode',
          sortable: false,
        },
        {
          text: 'Unidade/Setor Origem',
          align: 'center',
          value: 'departmentSourceName',
          sortable: false,
        },
        {
          text: 'Unidade/Setor Destino',
          align: 'center',
          value: 'departmentDestinyName',
          sortable: false,
        },
        {
          text: 'Data de Migração',
          align: 'center',
          value: 'dateFormated',
          sortable: false,
        },
        {
          text: 'Motivo de Migração',
          align: 'center',
          value: 'reason',
          sortable: false,
        },
      ],
      total: 0,
    }
  },

  computed: {
    indicator() {
      return getIndicatorById('historical_migration') || {}
    },
  },

  methods: {
    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('historical_migration').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      if (this.filterProp) this.filterProp.data = null
      this.list()
    },

    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
          const response = JSON.parse(this.filterProp.data)
          this.historicalMigration = []
          this.pager = response.content.pager
          this.totalPages = response.content.pager.totalPages
          this.total = response.content.pager.totalItems
          this.showChart = response.content.objects.length > 0

          response.content.objects.map((value) => {
            let dateFormated = moment(value.migretionDate).format('DD/MM/YYYY')
            this.historicalMigration.push({ ...value, dateFormated })
          })
          this.fillhistoricalMigrationChartData()
          return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService
          .post(this.apiEndpointOverride || 'reports/historicalMigration', this.filter)

        this.historicalMigration = []
        this.pager = response.content.pager
        this.totalPages = response.content.pager.totalPages
        this.total = response.content.pager.totalItems
        this.showChart = response.content.objects.length > 0

        response.content.objects.map((value) => {
          let dateFormated = moment(value.migretionDate).format('DD/MM/YYYY')
          this.historicalMigration.push({ ...value, dateFormated })
        })

        this.fillhistoricalMigrationChartData()
      } finally {
        this.loading = false
      }
    },
    fillhistoricalMigrationChartData() {
      this.historicalMigrationChartData = {
        labels: [''],
        datasets: [
          {
            label: this.$t('Calibrações Agendadas'),
            data: this.calibrationSchedule,
            backgroundColor: '#87AFA6',
          },
          {
            label: this.$t('Calibrações Executadas'),
            data: this.calibrationExecuted,
            backgroundColor: '#BAB3D3',
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
